// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"341":"3eecde17","379":"63fd566f"}[chunkId] + ".js";
};